import { reactive, UnwrapRef, getCurrentInstance, ComponentInternalInstance, ref, Ref } from '@vue/composition-api';
import dayjs from 'dayjs';

// 引入工具类
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import i18n, { i18n_t } from '@/locales/i18n';
import { ListItem } from '@/renderer/components/dialog/SelectFilePath/compositions/stencilHandler';
interface ColleborationUser {
  avatar: string;
  nickname: string;
  id?: number;
  role: string;
  authRoleId?: number;
  phoneNumber: string;
}
interface FormData {
  name: string;
  allowExternalUser: boolean;
  users: ColleborationUser[];
}
type Handler = {
  formData: UnwrapRef<FormData>;
  createLoading: Ref<Boolean>;
  rules: Object;
  methods: {
    initData: () => void;
    onCreate: (templateList?: ListItem[]) => Promise<number>;
  };
};
export default function handler(): Handler {
  // 当前组件
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const { $store } = vm;
  const createLoading = ref(false);

  const rules = {
    name: [
      {
        required: true,
        message: i18n_t('请输入群组名称'),
      },
      {
        validator: (val: string) => !val.includes('/'),
        message: i18n_t('名称不支持字符“/”'),
      },
    ],
  };

  const formData = reactive<FormData>({
    name: '',
    allowExternalUser: false,
    users: [],
  });
  const methods = {
    initData() {
      const currUserInfo = $store.getters.userBaseInfo as SMH.UserBaseInfo;
      formData.name = i18n_t('{slot1}创建的群组', { slot1: dayjs(Date.now()).format(i18n_t('MM月DD日')) });
      // 个人版只允许邀请所有用户,会议里默认邀请范围是所有用户
      formData.allowExternalUser = $store.getters.editionFlag === 'personal' || $store.getters.isInWeMeetApp;
      const { userId } = $store.getters;
      formData.users = [
        {
          avatar: currUserInfo.avatar,
          nickname: currUserInfo.nickname,
          id: userId,
          role: 'owner',
          phoneNumber: currUserInfo.phoneNumber,
        },
      ];
    },
    async onCreate(templateList?: ListItem[]) {
      tips.loading(i18n_t('创建中...'));
      const params = {
        name: formData.name,
        allowExternalUser: formData.allowExternalUser,
      };
      if (Array.isArray(templateList)) {
        const templateIds = templateList.map(item => item.id);
        Object.assign(params, {
          templateIds,
        });
      }
      try {
        createLoading.value = true;
        const { data } = await smh.userAPI.createCollaborationSpace(params);
        reporter.report('group', {
          group_build: 1,
          group_name: formData.name,
          group_template_detail: templateList?.map(item => item.templateName).join(','),
        });
        tips.success(i18n_t('协作群组创建成功'));
        createLoading.value = false;
        return data.id;
      } catch (error: MsgError) {
        if (error?.code === 'ShareGroupLimit') {
          reporter.report('group', {
            group_build: 0,
            group_name: formData.name,
            group_template_detail: templateList?.map(item => item.templateName).join(','),
          });
          openTeamPayDialog(PAY_SOURCE.CREATE_SHARE_GROUP_LIMIT);
        } else if (error?.code === 'NoPersonalSpace') {
          tips.error(i18n_t('管理员没有为您分配个人空间，无法创建协作空间。建议联系管理员开通个人空间'));
        } else {
          tips.error(error as MsgError);
        }
        createLoading.value = false;
        return -1;
      }
    },
  };
  return {
    formData,
    createLoading,
    rules,
    methods,
  };
}
